$(function() {
	const mySelect = document.getElementById('pl_courses_filter_category');
	if (mySelect)
		mySelect.addEventListener('change', function() {
			const selectedOption = mySelect.options[mySelect.selectedIndex];
			const catTitle = document.getElementById('pl_category_title');
			catTitle.innerText = selectedOption.text + ' (X cursos)';
		});
});
